import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

export const InputTextLabel = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
  mb: '7px',
})``;

export const StyledTextArea = styled.textarea`
  border: ${({ theme }) => `1px solid ${theme.colors.heavyLineOutline}`};
  background: ${({ theme }) => theme.colors.background};
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 14px;
  height: 109px;
  width: 100%;
  outline: 0;
  overflow: auto;
  padding: 10px;
  resize: none;
`;
export const BEErrorWrapper = styled(Box).attrs({
  py: 12,
  px: 20,
  bg: 'lightDanger',
  horizontal: true,
  color: 'background',
  flow: 12,
  borderRadius: 5,
  align: 'center',
})``;
